export type ExecutionSource = { orderId: number; dishName: string; quantity: number; venue: string };
export type ExecutionPreviewTask = {
  operationId: number | null;
  operationName: string;
  operationColor: string;
  componentKind: 'product' | 'semi' | 'dish';
  componentId: number | null;
  name: string;
  quantity: number;
  unit: string;
  instructions: string;
  preparationSteps?: Array<{
    title: string;
    instructions: string;
    estimatedMinutes: number | null;
    photoUrl?: string | null;
  }>;
  sources: ExecutionSource[];
};
export type ExecutionTask = ExecutionPreviewTask & {
  id: number;
  status: 'Waiting' | 'InProgress' | 'Completed' | 'Blocked';
  assignedUserId: string | null;
  assignedUserName: string;
  completedByName: string;
  startedAtUtc: string | null;
  completedAtUtc: string | null;
  durationMinutes: number | null;
  version: number;
  notes: string;
  canAct: boolean;
};
export type ExecutionBoard = {
  id: number; name: string; orderIds: number[]; employeeIds: string[];
  historicalOrderIds?: number[];
  kitchenId?: number | null; kitchenName?: string | null;
  createdAtUtc: string; version: number; tasks: ExecutionTask[];
};
export type ExecutionWorkspace = {
  canManage: boolean; employees: { id: string; name: string }[]; boards: ExecutionBoard[];
};
export const executionLabels: Record<ExecutionTask['status'], string> = {
  Waiting: 'Очікує', InProgress: 'В роботі', Completed: 'Готово', Blocked: 'Проблема',
};
export const executionColors: Record<ExecutionTask['status'], string> = {
  Waiting: 'var(--crm-text-muted)', InProgress: 'var(--crm-info)', Completed: 'var(--crm-success)', Blocked: 'var(--crm-danger)',
};
export function groupExecutionTasks<T extends ExecutionPreviewTask>(tasks: T[]) {
  const groups = new Map<string, { name: string; color: string; tasks: T[] }>();
  tasks.forEach(task => {
    const key = `${task.operationId ?? 'unmarked'}:${task.operationName}`;
    if (!groups.has(key)) groups.set(key, { name: task.operationName, color: task.operationColor, tasks: [] });
    groups.get(key)!.tasks.push(task);
  });
  return Array.from(groups.values());
}
